export default {
  getRequestListSelectedBid: state => state.requestListSelectedBid,
  getShopInfo: state => state.userShopInfo
}